import React from "react";
import styled from "styled-components";

export default styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: space-between;
`;
